
<p-panel>
    <div class="d-flex justify-content-left align-content-center">
        <div>
            @if (flag === 'edit') {
                <h4>Actualizar {{env.clienteName}}</h4>
            } @else {
                <h4>Crear {{env.clienteName}}</h4>
            }
        </div>
    </div>

    @if (flag === 'edit' && env.appName === 'ebro') {
        <div class="alert alert-info p-2 small">
            <b><i class="fa fa-exclamation-circle"></i> Atención:</b>
            La sincronización con el sistema Sage sobreescribirá toda la
            información editada aquí, excepto el campo <code>observaciones</code>.
        </div>

    }

   <div class="row">            
        <app-reactive-form-builder
                #formbuilder
                (formChanges)="formChanges($event[0], $event[1])"
                (goBack)="goBack()"
                (afterSend)="undefined"
                [form]="form.formFields"
                [serverUrl]="''"
                [dropdownLoadTrigger]="dropdownLoadTrigger"
                [previousData]="getModel()"
                [request]="getType() === 1 ? clientesApi.clientesPUT : clientesApi.clientesPOST"
                [getRequest]="clientesApi.clientesGET">
        </app-reactive-form-builder>
    </div>
</p-panel>
<br>
